import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import SweetAlert from 'react-bootstrap-sweetalert';
import { wsUpdate } from 'services/WService';
import { FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

export default function AmountModal(props) {
  const documentCustomer = props.model;
  const { setAlert, hideAlert, classes, showNotify, reload, dataOrigin } = props;

  const [dataChanging, setDataChanging] = useState(documentCustomer);

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  const [checkPay, setCheckPay] = useState(false);

  const handleCheckboxChange = (event) => {
    setCheckPay(event.target.checked);
  };

  let amount = '';
  if (checkPay) {
    amount = dataChanging.SumApplied ?? 0;
  } else {
    amount = documentCustomer.SumApplied;
  }

  const hideSave = (dataOrigin[0]?.state === '5' || dataOrigin[0]?.state === 'L') && documentCustomer?.DocStatus === 'C';
  return (
    <Modal
      title={`Documento del cliente ${documentCustomer.CardName}`}
      model={documentCustomer}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      hideSave={hideSave}
      entity={'prog/sheet-document'}
      dataForce={{
        advance_payment: checkPay ? 'Y' : 'N'
      }}
    >
      <FormControlLabel fullWidth margin="normal" size="small"
        control={
          <Checkbox
            checked={checkPay}
            onChange={handleCheckboxChange}
          />
        }
        label="Concepto"
        classes={{ label: classes.titleCheckBox }}
      />
      <TextField
        label="Total documento"
        fullWidth
        name="SumApplied"
        margin="normal"
        type="number"
        disabled={checkPay === false}
        value={amount}
        onChange={(e) => handleChange('SumApplied', e.target.value)}
        inputProps={{
          max: documentCustomer.DocTotal,
          min: 0,
          step: 0.01
        }}
      />
    </Modal>
  );
}
